import React, { useMemo } from "react";

import PackageSelect from "./PackageSelect";

import { FmDrawer, FmImage } from "@/ui-component";
import {
    usePackageInfoContext,
    useProductDetailsContext,
    useRateContext,
} from "@/src/provider";
import classnames from "classnames";
import stl from "./selectContainer.module.scss";
import SelectLenses from "../ColorComfirmBtn/SelectLenses";
// TODO: 这个模块好像没完，没复现对应功能
import { useTranslation } from "@/src/i18n/client";

interface IProps {
    visible: boolean;
    onClose: () => void;
}

const SelectlensModal: React.FC<IProps> = (props) => {
    // const packageSelectRef = useRef<HTMLDivElement>(null);
    const { t } = useTranslation("productDetail");
    // const selecUsagetNotice = () => {
    //     packageSelectRef.current?.selecUsagetNotice();
    // };
    const [getPrice] = useRateContext((state) => [state.getPrice]);

    const { onClose, visible } = props;

    const [productDetail, activeObj, productImgList] = useProductDetailsContext(
        (state) => [state.productDetail, state.activeObj, state.productImgList],
    );

    const [packageInfoIsPackage, active_package] = usePackageInfoContext(
        (state) => [state.isPackage, state.active_package],
    );
    const activeImg = useMemo(() => {
        return productImgList.length > 1
            ? productImgList[1]
            : productImgList[0];
    }, [productImgList]);
    const isPackage = useMemo(() => {
        return packageInfoIsPackage && productDetail.meedPackage;
    }, [packageInfoIsPackage, productDetail.meedPackage]);
    const active_package_price = active_package.price
        ? parseFloat(active_package.price)
        : 0;

    return (
        <FmDrawer
            anchor="bottom"
            closeable
            open={visible}
            onClose={onClose}
            headerChildren
        >
            <div className={stl["select-package-container"]}>
                <div className={stl["select-package-content"]}>
                    {/* 图片 */}
                    <div
                        className={classnames(
                            "default_layout",
                            stl["select-package-img"],
                        )}
                    >
                        <div className={stl["active-img"]}>
                            <FmImage image={activeImg} />
                        </div>
                        {/* 价格 */}
                        <div
                            className={classnames(
                                "default_layout",
                                stl["price-container"],
                            )}
                            // column={true}
                        >
                            <div className={stl["price"]}>
                                <b
                                    dangerouslySetInnerHTML={{
                                        __html: getPrice(
                                            parseFloat(
                                                activeObj.onsale?.price.toString() ??
                                                    "",
                                            ) + active_package_price,
                                        ),
                                    }}
                                />
                                {activeObj.onsale?.showDiscount && (
                                    <s
                                        dangerouslySetInnerHTML={{
                                            __html: getPrice(
                                                parseFloat(
                                                    activeObj.price?.price.toString() ??
                                                        "",
                                                ) + active_package_price,
                                            ),
                                        }}
                                    />
                                )}
                            </div>
                            {/* 价格，包含套餐提示 */}
                            {active_package.package_id &&
                            active_package.package_id > 0 ? (
                                <p className={stl["package-lens-text"]}>
                                    {" "}
                                    <i>
                                        {t(
                                            "productDetail:PackageInfo.Selected",
                                        )}
                                        : {active_package.name}
                                    </i>
                                </p>
                            ) : (
                                ""
                            )}
                            {isPackage &&
                            (!active_package.package_id ||
                                active_package.package_id <= 0) ? (
                                <p className={stl["package-lens-text"]}>
                                    {" "}
                                    <i>
                                        {t(
                                            "productDetail:PackageInfo.FrameCost",
                                        )}
                                    </i>
                                </p>
                            ) : (
                                ""
                            )}
                        </div>
                    </div>
                    {/* 颜色切换 */}
                    {/* <ColorSelect /> */}
                    <hr />
                    <PackageSelect />
                </div>
                <hr style={{ marginBottom: "0.13rem" }} />
                <div className={"default_layout"}>
                    <div style={{ width: "4.6rem", height: "0.72rem" }}>
                        <SelectLenses
                        // selecUsagetNotice={selecUsagetNotice}
                        />
                    </div>
                </div>
            </div>
        </FmDrawer>
    );
};

export default SelectlensModal;
